export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 pt-[72px]">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20red%20velvet%20curtains%20slightly%20parted%2C%20spotlight%20casting%20long%20shadows%2C%20empty%20theater%20stage%2C%20warm%20crimson%20and%20dark%20atmosphere%2C%20mysterious%20performance%20venue%2C%20cinematic%20lighting%2C%20abstract%20artistic%20composition%2C%20no%20people&width=1600&height=1000&seq=hero-bg-main&orientation=landscape"
          alt="每日吃瓜娱乐爆料背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-sm font-medium text-accent-300">今日已更新 23 条爆料</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              每日吃瓜 — 全网最全明星黑料深扒平台
            </h1>

            <p className="text-base md:text-lg font-bold text-accent-400 mb-6">
              让每一个真相，都不再沉默
            </p>

            <div className="space-y-3 text-sm md:text-base text-background-200 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                聚焦娱乐圈最热明星黑料、黑历史曝光与内幕深扒，每日更新最新娱乐丑闻、塌房事件及行业黑幕。从选秀造假到税务调查，从整容翻车到情感纠纷，覆盖你能想到的所有吃瓜维度。
              </p>
              <p>
                全网信息实时聚合，独家线人深度爆料，严谨事实核查保障内容质量。当前热门追踪：顶流塌房、综艺翻车、演员违法失德系列，点击下方入口即刻进入吃瓜时刻。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">50+</div>
                <div className="text-xs text-background-300 mt-1">日均爆料</div>
              </div>
              <div className="w-px h-10 bg-background-400/30"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">800万+</div>
                <div className="text-xs text-background-300 mt-1">吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-400/30"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">24h</div>
                <div className="text-xs text-background-300 mt-1">全天候更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap"
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-transparent border border-background-300/50 text-background-100 font-medium rounded-lg hover:bg-background-50/10 transition-colors duration-200 text-center whitespace-nowrap"
              >
                查看热榜 <i className="ri-fire-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20shattered%20theater%20masks%20and%20broken%20spotlight%20bulbs%20floating%20in%20darkness%2C%20dramatic%20crimson%20and%20gold%20lighting%2C%20surreal%20atmosphere%2C%20elegant%20decay%20aesthetic%2C%20fine%20art%20photography%20style%2C%20mysterious%20and%20powerful%20visual%2C%20high%20contrast%2C%20no%20people&width=800&height=900&seq=hero-visual-main&orientation=portrait"
                alt="每日吃瓜主编视觉"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '4/5' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}